<template>
  <tr style="cursor: pointer" @click="toggleEditDialog()">
    <td v-for="(header,i) in headers" :key="i" :class="`text-xs-${header.align}`">
      <span v-if="header.type == 'text'">{{ getObjectPath(header.value, userAuthClassObj) || "-" }}</span>

      <span v-else-if="header.type =='action'" @click.stop>
        <v-menu bottom left>
          <v-btn icon flat color="grey" slot="activator">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            <basic-list-tile title="Edit" icon="edit" :onClick="toggleEditDialog"></basic-list-tile>
            <basic-list-tile
              title="Delete"
              icon="delete"
              color="red lighten-3"
              :onClick="toggleDeleteDialog"
            ></basic-list-tile>
          </v-list>
        </v-menu>
      </span>

      <span v-else>
        <span v-if="getObjectPath(header.value, userAuthClassObj)">
          <v-icon color="green">check</v-icon>
        </span>
        <span v-else>
          <v-icon color="red">close</v-icon>
        </span>
      </span>
    </td>
    <!-- END CELLS -->

    <v-dialog v-model="editDialog" max-width="500px" @keydown.esc="editDialog = false" lazy>
      <user-auth-class-edit @close="editDialog = false" :item="userAuthClassObj"></user-auth-class-edit>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400px" @keydown.esc="editDialog = false" lazy>
      <confirmation-card title="Delete Authorization Class?" :subText="` (${userAuthClassObj.id})`">
        <v-btn color="grey darken-1" flat @click="close()">Cancel</v-btn>
        <v-btn
          flat
          @click="deleteUserAuthClass()"
          color="red darken-1"
          :loading="loading"
          :disabled="userAuthClassObj.id == 1"
        >Delete Authorization Class</v-btn>
      </confirmation-card>
    </v-dialog>
  </tr>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import UserAuthClassEdit from "./userAuthClassEdit";
import Api from "@/services/api";
export default {
  data() {
    return {
      editDialog: false,
      deleteDialog: false,
      loading: false
    };
  },
  methods: {
    toggleEditDialog() {
      this.editDialog = !this.editDialog;
    },
    toggleDeleteDialog() {
      this.deleteDialog = !this.deleteDialog;
    },
    deleteUserAuthClass() {
      this.loading = true;
      Api.delete(`user/userAuthClass/${this.userAuthClassObj.id}`)
        .then(result => {
          this.snack({
            text: "Authorization Class was deleted!",
            color: "yellow"
          });
          this.$store.commit("users/setState", {
            prop: "fetchUserAuthClasses",
            value: true
          });
          this.deleteDialog = false;
          this.loading = false;
        })
        .catch(err => {
          this.snack({ text: err.response.data.message, color: "red" });
          this.loading = false;
        });
    }
  },
  computed: {},
  props: {
    userAuthClassObj: Object,
    headers: Array
  },
  components: {
    UserAuthClassEdit
  }
};
</script>

<style>
</style>
